<div class="container">
  <div class="app-loading" *ngIf="appLoading">
    <div class="logo">
      <svg class="spinner" viewBox="25 25 50 50">
        <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10"/>
      </svg>
    </div>
    <span>Caricamento...</span>
  </div>
  <div class="row">
    <div class="col-md-12">
      <h1 rtl class="main-heading">Note</h1>
    </div>
  </div>
  <div *ngIf="note.length === 0">
    <div class="row d-flex justify-content-center" [ngClass]="routeAnimationsElements">
      <p><img src="assets/cupido.png"/></p>
    </div>
    <div class="row d-flex justify-content-center" [ngClass]="routeAnimationsElements">
      <p>Nessuna nota presente su questa pratica.</p>
    </div>
  </div>
  <div class="row" *ngIf="note.length !== 0">
    <div class="col">
      <mat-card *ngFor="let nota of note" [ngClass]="routeAnimationsElements">
        <mat-card-title>
          {{ nota.ntcrUtenteNota }}
        </mat-card-title>
        <mat-card-subtitle rtl>
          {{ nota.ntcrDataNota | date: 'dd/MM/yyyy HH:mm' }}
        </mat-card-subtitle>
        <mat-card-content>
          <p>
            {{ nota.ntcrTestoNota }}
          </p>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
